import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader";
import fetchApi from "../../../../utils/fetchApi";

export default function ReviewChallenge() {
  const { challengeId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState();
  const [qrCodeSrc, setQrCodeSrc] = useState("");
  const [eventReward, setEventReward] = useState();
  const [rejectionCause, setRejectionCause] = useState("");
  const [denyState, setDenyState] = useState("");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [entryValues, setEntryValues] = useState({});
  const [rowLoading, setRowLoading] = useState({});
  const [isTypeReward, setIsTypeReward] = useState(false);

  // Helpers
  const normalizeDigits = val =>
    String(val ?? "")
      .replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) // Persian -> Latin
      .replace(/[,\u066B\u066C\u060C]/g, ""); // commas/Arabic separators

  const toNumber = val => {
    const n = Number(normalizeDigits(val));
    return Number.isFinite(n) ? n : null;
  };

  const maxChallengeReward = toNumber(eventDetails?.reward);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const data = await fetchApi(
          "GET",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
          }
        );
        setEventDetails(data?.data);
        if (data?.data?.eventCategory?.type?.calculateScoreBySystem === false)
          setIsTypeReward(true);
        // setQrCodeSrc(data?.info?.qrCode);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (eventDetails?.status === 2 || eventDetails?.status === 3) {
      (async () => {
        try {
          const data = await fetchApi(
            "GET",
            `${
              window?.location?.origin?.includes("localhost")
                ? `${process.env.REACT_APP_API_URL}`
                : `${process.env.REACT_APP_API_URL}`
            }/event/rejections/descriptions`,
            {
              headers: {},
              params: { challengeId },
            }
          );
          setRejectionCause(data?.info[0]?.description);
        } catch (error) {
        } finally {
        }
      })();
    }
  }, [eventDetails]);

  // #region ==API==> Event Leaderboard
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await fetchApi(
        "GET",
        `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/organizations/leaderboard/event`,
        {
          headers: {},
          params: {
            orgId: localStorage.getItem("orgId"),
            eventId: challengeId,
            limit: 50,
            page: 1,
          },
        }
      );
      setLeaderboardData(data?.data?.items);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // #endregion

  useEffect(() => {
    if (isTypeReward && leaderboardData.length) {
      setEntryValues(prev => {
        const next = { ...prev };
        leaderboardData.forEach(itm => {
          if (!next[itm.id]) {
            next[itm.id] = { amount: itm.activity ?? "", description: "" };
          }
        });
        return next;
      });
    }
  }, [isTypeReward, leaderboardData]);

  //#region Copy Text handler

  const handleCopyClick = () => {
    navigator.clipboard.writeText(eventDetails?.id).then(() => {
      toast.success("کد رویداد کپی شد");
    });
  };

  //#endregion

  const handleQrCodeDownload = () => {
    // Create a temporary <a> element
    const link = document.createElement("a");
    link.href = qrCodeSrc; // Set the image source
    link.download = "QRCode.png"; // Set the file name
    link.click(); // Programmatically trigger a click
  };

  const approveEvent = async () => {
    if (eventReward) {
      try {
        await fetchApi(
          "PATCH",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/approve/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { reward: eventReward },
          }
        );
        toast.success("رویداد با موفقیت تایید گردید.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("لطفا امتیاز رویداد را وارد کنید.");
  };

  const rejectEvent = async () => {
    if (rejectionCause) {
      try {
        await fetchApi(
          "PATCH",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/reject/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { description: rejectionCause },
          }
        );
        toast.success("رویداد با موفقیت رد شد.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("علت رد کردن رویداد را وارد کنید.");
  };

  const cancelEvent = async () => {
    if (rejectionCause) {
      try {
        await fetchApi(
          "PATCH",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/cancel/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { description: rejectionCause },
          }
        );
        toast.success("رویداد با موفقیت لغو شد.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("علت لغو رویداد را وارد کنید.");
  };

  const finalizeEvent = async () => {
    if (rejectionCause) {
      try {
        await fetchApi(
          "PATCH",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/finalize/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { description: rejectionCause },
          }
        );
        toast.success("رویداد با موفقیت نهایی شد.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("توضیح نهایی کردن رویداد را وارد کنید.");
  };

  const sendToSuperAdmin = async () => {
    if (rejectionCause) {
      try {
        await fetchApi(
          "POST",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/send-to-super-admin/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { description: rejectionCause },
          }
        );
        toast.success("رویداد با موفقیت به سوپر ادمین ارجاع داده شد.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("توضیح را وارد کنید.");
  };

  const returnToAdmin = async () => {
    if (rejectionCause) {
      try {
        await fetchApi(
          "POST",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/events/return-event/${challengeId}`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
            },
            data: { description: rejectionCause },
          }
        );
        toast.success("رویداد با موفقیت به ادمین برگشت داده شد.");
        setTimeout(() => {
          window?.location?.reload();
        }, 2000);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    } else toast.error("توضیح را وارد کنید.");
  };

  const renderActionBtns = (status, role = localStorage?.getItem("role")) => {
    switch (status) {
      case "PENDING": {
        return (
          <div className={`flex items-center gap-2.5`}>
            <button
              className={`btn rounded-lg bg-myGreen34A hover:bg-myGreen34A hover:scale-105 text-white`}
              onClick={() =>
                document.getElementById("approve_modal").showModal()
              }
            >
              تایید درخواست
            </button>
            <button
              className={`btn rounded-lg bg-[#C80707] hover:bg-[#C80707] hover:scale-105 text-white`}
              onClick={() => {
                document.getElementById("deny_modal").showModal();
                setDenyState("reject");
              }}
            >
              رد درخواست
            </button>
          </div>
        );
      }

      case "APPROVED": {
        return (
          <div className={`flex items-center gap-2.5`}>
            <button
              className={`btn rounded-lg bg-myBlue257 hover:bg-myBlue257 hover:scale-105 text-white`}
              onClick={() => {
                document.getElementById("deny_modal").showModal();
                setDenyState("cancel");
              }}
            >
              لغو چالش
            </button>
          </div>
        );
      }

      case "TIME_ENDED": {
        if (
          (role === "SUPER_ADMIN" || role === "ADMIN") &&
          eventDetails?.eventCategory?.type?.dataEntryType === "ADMIN"
        )
          return (
            <div className={`flex items-center gap-2.5`}>
              <button
                className={`btn rounded-lg bg-myBlue257 hover:bg-myBlue257 hover:scale-105 text-white`}
                onClick={() => {
                  document.getElementById("deny_modal").showModal();
                  setDenyState("sendToSuperAdmin");
                }}
              >
                ارجاع به سوپر ادمین
              </button>
            </div>
          );
        break;
      }

      case "TARGET_MET": {
        if (
          (role === "SUPER_ADMIN" || role === "ADMIN") &&
          eventDetails?.eventCategory?.type?.dataEntryType === "ADMIN"
        )
          return (
            <div className={`flex items-center gap-2.5`}>
              <button
                className={`btn rounded-lg bg-myBlue257 hover:bg-myBlue257 hover:scale-105 text-white`}
                onClick={() => {
                  document.getElementById("deny_modal").showModal();
                  setDenyState("sendToSuperAdmin");
                }}
              >
                ارجاع به سوپر ادمین
              </button>
            </div>
          );
        break;
      }

      case "NEED_ADMIN_REVIEW": {
        if (
          role === "SUPER_ADMIN" &&
          eventDetails?.eventCategory?.type?.dataEntryType === "ADMIN"
        )
          return (
            <div className={`flex items-center gap-2.5`}>
              <button
                className={`btn rounded-lg bg-myGreen34A hover:bg-myGreen34A hover:scale-105 text-white`}
                onClick={() => {
                  document.getElementById("deny_modal").showModal();
                  setDenyState("finalize");
                }}
              >
                تایید نهایی
              </button>
              <button
                className={`btn rounded-lg bg-[#C80707] hover:bg-[#C80707] hover:scale-105 text-white`}
                onClick={() => {
                  document.getElementById("deny_modal").showModal();
                  setDenyState("sendToAdmin");
                }}
              >
                برگشت به ادمین
              </button>
            </div>
          );
        break;
      }

      default: {
        break;
      }
    }
  };

  const handleDenyRequest = async state => {
    switch (state) {
      case "reject": {
        await rejectEvent();
        break;
      }

      case "cancel": {
        await cancelEvent();
        break;
      }

      case "sendToSuperAdmin": {
        await sendToSuperAdmin();
        break;
      }

      case "finalize": {
        await finalizeEvent();
        break;
      }

      case "sendToAdmin": {
        await returnToAdmin();
        break;
      }

      default: {
        break;
      }
    }
  };

  const submitDataEntry = async memberId => {
    const amountNum = toNumber(entryValues[memberId]?.amount);
    const description = entryValues[memberId]?.description?.trim() || "";

    if (amountNum === null) {
      toast.error("مقدار نامعتبر است.");
      return;
    }

    setRowLoading(s => ({ ...s, [memberId]: true }));
    try {
      await fetchApi(
        "POST",
        `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/organizations/events/admin-data-entry/${challengeId}`,
        {
          headers: {},
          params: {
            orgId: localStorage.getItem("orgId"),
          },
          data: {
            memberId,
            amount: amountNum,
            description,
          },
        }
      );
      toast.success("ثبت شد.");
      fetchData();
    } catch (error) {
      toast.error("خطا در ثبت.");
    } finally {
      setRowLoading(s => ({ ...s, [memberId]: false }));
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className={`w-full flex flex-col`}>
            <div
              className={`w-full pb-7 border-b border-myNeutralBorder flex justify-between items-center max-lg:hidden`}
            >
              <div className={`flex items-center gap-4`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.9319 10.4745C8.83554 10.4649 8.71991 10.4649 8.61391 10.4745C6.3205 10.3974 4.49927 8.51838 4.49927 6.2057C4.49927 3.84484 6.40723 1.92725 8.77772 1.92725C11.1386 1.92725 13.0562 3.84484 13.0562 6.2057C13.0465 8.51838 11.2253 10.3974 8.9319 10.4745Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.919 3.85449C17.7884 3.85449 19.2916 5.36737 19.2916 7.22715C19.2916 9.04838 17.8462 10.5324 16.0442 10.5998C15.9672 10.5902 15.8804 10.5902 15.7937 10.5998"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.11395 14.0301C1.782 15.5911 1.782 18.1351 4.11395 19.6865C6.7639 21.4596 11.1098 21.4596 13.7598 19.6865C16.0917 18.1255 16.0917 15.5815 13.7598 14.0301C11.1194 12.2667 6.77353 12.2667 4.11395 14.0301Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7783 19.2724C18.4721 19.1279 19.1274 18.8484 19.667 18.4341C21.1702 17.3066 21.1702 15.4469 19.667 14.3194C19.137 13.9147 18.4914 13.6449 17.8072 13.4907"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={`text-myBlack414 text-lg font-bold`}>
                  مشخصات چالش{" "}
                  {eventDetails?.status === "APPROVED"
                    ? "تایید شده"
                    : eventDetails?.status === "PENDING"
                    ? "درخواست شده"
                    : eventDetails?.status === "REJECTED"
                    ? "رد شده"
                    : eventDetails?.status === "NEED_ADMIN_REVIEW"
                    ? "نیازمند تایید"
                    : eventDetails?.status === "FINISHED"
                    ? "تمام شده"
                    : eventDetails?.status === "TARGET_MET"
                    ? "رسیده به هدف"
                    : eventDetails?.status === "TIME_ENDED"
                    ? "اتمام زمان"
                    : "لغو شده"}
                </span>
              </div>
              <div className={`flex items-center gap-3`}>
                {renderActionBtns(eventDetails?.status)}
                <button
                  className="btn rounded-lg bg-[#FBBC05] hover:bg-[#FBBC05] text-black"
                  onClick={() =>
                    navigate(
                      `/dashboard/challenges/new?challengeId=${challengeId}&copied=true`
                    )
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M13.5053 10.8887V14.4338C13.5053 17.388 12.3236 18.5697 9.36932 18.5697H5.8242C2.86994 18.5697 1.68823 17.388 1.68823 14.4338V10.8887C1.68823 7.93439 2.86994 6.75269 5.8242 6.75269H9.36932C12.3236 6.75269 13.5053 7.93439 13.5053 10.8887Z"
                      stroke="black"
                      strokeWidth="1.26611"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.5697 5.8242V9.36932C18.5697 12.3236 17.388 13.5053 14.4338 13.5053H13.5053V10.8887C13.5053 7.93439 12.3236 6.75269 9.36932 6.75269H6.75269V5.8242C6.75269 2.86994 7.93439 1.68823 10.8887 1.68823H14.4338C17.388 1.68823 18.5697 2.86994 18.5697 5.8242Z"
                      stroke="black"
                      strokeWidth="1.26611"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  کپی کردن چالش
                </button>
              </div>
            </div>
            <div
              className={`mt-8 flex max-lg:flex-col-reverse justify-between max-lg:items-center max-lg:gap-9 w-full`}
            >
              <div className={`flex flex-col gap-7 w-full`}>
                <div className={`flex lg:items-center gap-7 max-lg:flex-col`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>نام چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.title}
                    </span>
                  </div>
                  {/* <div className={`flex items-center gap-2 max-lg:w-full`}>
                    <span className={`text-[#616161]`}>امتیاز تعریف چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {
                        eventDetails?.eventCategory
                          ?.creatorGainChallengeScorePercent
                      }{" "}
                      درصد از ساخت چالش و{" "}
                      {
                        eventDetails?.eventCategory
                          ?.creatorGainParticipantsScorePercent
                      }{" "}
                      درصد از فعالیت شرکت‌کنندگان
                    </span>
                  </div> */}
                </div>
                <div className={`flex lg:items-center gap-7 max-lg:flex-col`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>دسته‌بندی چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.eventCategory?.name}
                    </span>
                  </div>
                  <div
                    className={`flex items-center gap-2 max-lg:w-full ${
                      isTypeReward ? "hidden" : ""
                    }`}
                  >
                    <span className={`text-[#616161]`}>
                      امتیاز شرکت در چالش:
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {
                        eventDetails?.eventCategory
                          ?.challengeParticipationPercent
                      }{" "}
                      درصد
                    </span>
                  </div>
                </div>
                <div className={`flex lg:items-center gap-7 max-lg:flex-col`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>
                      نوع دسته‌بندی چالش:‌
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.eventCategory?.type?.name}
                    </span>
                  </div>
                  <div
                    className={`flex items-center gap-2 max-lg:w-full ${
                      isTypeReward ? "hidden" : ""
                    }`}
                  >
                    <span className={`text-[#616161]`}>امتیاز نفر اول:‌</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.eventCategory?.firstPlacePercent} درصد
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>وضعیت چالش:‌</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.status === "PENDING"
                        ? "در انتظار بررسی"
                        : eventDetails?.status === "APPROVED"
                        ? "تایید شده"
                        : eventDetails?.status === "REJECTED"
                        ? "رد شده"
                        : eventDetails?.status === "CANCELED"
                        ? "لغو شده"
                        : eventDetails?.status === "NEED_ADMIN_REVIEW"
                        ? "نیازمند بررسی ادمین"
                        : "برگزار شده"}
                    </span>
                  </div>
                  <div
                    className={`flex items-center gap-2 max-lg:w-full ${
                      isTypeReward ? "hidden" : ""
                    }`}
                  >
                    <span className={`text-[#616161]`}>امتیاز نفر دوم‌:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.eventCategory?.secondPlacePercent} درصد
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>ثبت کننده چالش:‌</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.agentName}
                    </span>
                  </div>
                  <div
                    className={`flex items-center gap-2 max-lg:w-full ${
                      isTypeReward ? "hidden" : ""
                    }`}
                  >
                    <span className={`text-[#616161]`}>امتیاز نفر سوم:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.eventCategory?.thirdPlacePercent} درصد
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>
                      تعداد شرکت کنندگان:‌
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.reserved} نفر
                    </span>
                  </div>
                  {eventDetails?.endType === "TARGET" && (
                    <div className={`flex items-center gap-2 max-lg:w-full`}>
                      <span className={`text-[#616161]`}>هدف چالش:‌</span>
                      <span className={`text-[#616161] font-bold`}>
                        {eventDetails?.target}{" "}
                        {eventDetails?.eventCategory?.indicatorMeasurementUnit}
                      </span>
                    </div>
                  )}
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>
                      زمان شروع ثبت‌نام:‌
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {moment(eventDetails?.registrationStartsAt).format(
                        "jYYYY/jMM/jDD ساعت HH:mm"
                      )}
                    </span>
                  </div>
                  <div className={`flex items-center gap-2 max-lg:w-full`}>
                    <span className={`text-[#616161]`}>زمان شروع چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {moment(eventDetails?.startDate).format(
                        "jYYYY/jMM/jDD ساعت HH:mm"
                      )}
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>
                      زمان پایان ثبت‌نام:‌
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {moment(eventDetails?.registrationEndsAt).format(
                        "jYYYY/jMM/jDD ساعت HH:mm"
                      )}
                    </span>
                  </div>
                  <div className={`flex items-center gap-2 max-lg:w-full`}>
                    <span className={`text-[#616161]`}>زمان پایان چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {moment(eventDetails?.endDate).format(
                        "jYYYY/jMM/jDD ساعت HH:mm"
                      )}
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>امتیاز چالش:‌</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.reward}
                    </span>
                  </div>
                  <div className={`flex items-center gap-2 max-lg:w-full`}>
                    <span className={`text-[#616161]`}>مسئول چالش:</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.agentName}
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-9 max-lg:flex-wrap`}>
                  <div className={`flex items-center gap-2 w-full lg:w-1/2`}>
                    <span className={`text-[#616161]`}>هزینه ثبت نام:‌</span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.registrationFee}
                    </span>
                  </div>
                  <div className={`flex items-center gap-2 max-lg:w-full`}>
                    <span className={`text-[#616161]`}>
                      شماره موبایل مسئول چالش:
                    </span>
                    <span className={`text-[#616161] font-bold`}>
                      {eventDetails?.agentMobileNumber}
                    </span>
                  </div>
                </div>
                <div className={`flex items-center gap-2 text-wrap`}>
                  <span className={`text-[#616161] whitespace-nowrap`}>
                    جزئیات چالش:
                  </span>
                  <span className={`text-[#616161] font-bold`}>
                    {eventDetails?.description}
                  </span>
                </div>

                {/* If Approved */}
                {/* {eventDetails?.status === 1 && (
                  <div
                    className={`w-full flex justify-between items-center max-lg:flex-col gap-7`}
                  >
                    <div className={`flex flex-col gap-7`}>
                      <div className={`flex items-center gap-3`}>
                        <span className={`text-[#616161]`}>کد رویداد:‌</span>
                        <span className={`text-[#B4260F] font-bold`}>
                          {eventDetails?.id}
                        </span>
                        <button
                          onClick={handleCopyClick}
                          className={`btn p-0 bg-white hover:bg-white hover:scale-105`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                      <button
                        onClick={handleQrCodeDownload}
                        className={`btn text-myNeutralBackground text-sm font-bold bg-[#4285F4] hover:bg-[#4285F4] w-fit hover:scale-105`}
                      >
                        دانلود QR
                      </button>
                    </div>
                    <div
                      className={`size-28 border-myBrandRed border rounded-2xl overflow-hidden`}
                    >
                      <img src={qrCodeSrc} alt="Event Qr code" />
                    </div>
                  </div>
                )} */}
              </div>
              <div className={`lg:w-[185px] flex flex-col gap-4 items-center`}>
                <div className={`w-full aspect-square max-lg:w-[185px]`}>
                  <img
                    className={`rounded-lg w-full aspect-square object-cover`}
                    src="/img/dashboard/green earth NGO Yellow.png"
                    alt="Event Avatar"
                  />
                </div>
                <button
                  disabled
                  className={`btn text-myNeutralBackground font-bold w-[132px] bg-[#FBBC05] rounded-lg hover:bg-[#FBBC05] hover:scale-105 max-lg:hidden`}
                >
                  ثبت تصویر
                </button>
                <div
                  className={`w-full flex justify-center items-center gap-2.5 lg:hidden`}
                >
                  {renderActionBtns(eventDetails?.status)}
                  <button
                    className="btn rounded-lg bg-[#FBBC05] hover:bg-[#FBBC05] text-black"
                    onClick={() =>
                      navigate(
                        `/dashboard/challenges/new?challengeId=${challengeId}&copied=true`
                      )
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M13.5053 10.8887V14.4338C13.5053 17.388 12.3236 18.5697 9.36932 18.5697H5.8242C2.86994 18.5697 1.68823 17.388 1.68823 14.4338V10.8887C1.68823 7.93439 2.86994 6.75269 5.8242 6.75269H9.36932C12.3236 6.75269 13.5053 7.93439 13.5053 10.8887Z"
                        stroke="black"
                        strokeWidth="1.26611"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.5697 5.8242V9.36932C18.5697 12.3236 17.388 13.5053 14.4338 13.5053H13.5053V10.8887C13.5053 7.93439 12.3236 6.75269 9.36932 6.75269H6.75269V5.8242C6.75269 2.86994 7.93439 1.68823 10.8887 1.68823H14.4338C17.388 1.68823 18.5697 2.86994 18.5697 5.8242Z"
                        stroke="black"
                        strokeWidth="1.26611"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    کپی کردن چالش
                  </button>
                </div>
                {eventDetails?.qrCode && (
                  <div className={`flex flex-col gap-3`}>
                    <img src={eventDetails?.qrCode} alt="QrCode" />
                    <button
                      className="btn bg-myBlue257 hover:bg-myBlue257 text-white"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = eventDetails?.qrCode; // your base64 string
                        link.download = "qrcode.png"; // filename
                        link.click();
                      }}
                    >
                      دانلود QR
                    </button>
                  </div>
                )}

                {eventDetails?.endType === "PRESENCE" && (
                  <div className={`flex flex-col gap-2`}>
                    <span>کد چالش:</span>
                    <div className={`flex items-center gap-2 max-lg:w-full`}>
                      <span>{eventDetails?.id}</span>
                      <button
                        className="btn btn-xs"
                        onClick={() => {
                          navigator.clipboard
                            .writeText(eventDetails?.id)
                            .then(() => {
                              toast.success("کد چالش کپی شد");
                            });
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeinejoin="round"
                          />
                          <path
                            d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Approval Modal */}
            <dialog id="approve_modal" className={`modal`}>
              <div className="modal-box bg-white">
                <div className={`flex flex-col items-center gap-10`}>
                  <div
                    className={`flex flex-col justify-center items-center gap-6 w-full`}
                  >
                    <span className={`text-[#6F6F6F] text-2xl font-bold`}>
                      امتیاز رویداد
                    </span>
                    <input
                      autoFocus
                      type="tel"
                      value={eventReward}
                      onChange={e => {
                        // Ensure the value is numeric and non-negative
                        const value = e.target.value.replace(/\D/g, ""); // Remove any non-digit characters
                        setEventReward(value);
                      }}
                      onKeyDown={e => {
                        // Prevent minus sign and other invalid keys
                        if (e.key === "-" || e.key === "+" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      className={`w-full input bg-white text-center border border-[#D6D6D6] rounded-lg text-xl text-myNeutralTitle font-medium`}
                    />
                  </div>
                  <form
                    method="dialog"
                    className={`w-full max-w-36 h-12 rounded-xl flex justify-between lg:justify-center items-center gap-8`}
                  >
                    <button
                      onClick={approveEvent}
                      className={`btn bg-myGreen34A hover:bg-myGreen34A rounded-lg font-bold text-white w-[182px]`}
                      style={{ border: "1px solid" }}
                    >
                      تایید امتیاز
                    </button>
                  </form>
                </div>
              </div>
              <form method="dialog" className="modal-backdrop">
                <button>close</button>
              </form>
            </dialog>

            {/* Deny Modal */}
            <dialog id="deny_modal" className={`modal`}>
              <div className="modal-box bg-white">
                <div className={`flex flex-col items-center gap-10`}>
                  <div className={`flex items-center gap-2.5 w-full`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M8.33334 4.99984H11.6667C13.3333 4.99984 13.3333 4.1665 13.3333 3.33317C13.3333 1.6665 12.5 1.6665 11.6667 1.6665H8.33334C7.50001 1.6665 6.66667 1.6665 6.66667 3.33317C6.66667 4.99984 7.50001 4.99984 8.33334 4.99984Z"
                        stroke="#414A53"
                        strokeWidth="1.25"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                        stroke="#414A53"
                        strokeWidth="1.25"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className={`text-[#6F6F6F] text-2xl font-bold`}>
                      علت
                    </span>
                  </div>
                  <textarea
                    autoFocus
                    rows="4"
                    value={rejectionCause}
                    onChange={e => setRejectionCause(e.target.value)}
                    placeholder="چیزی بنویسید ..."
                    className={`w-full textarea bg-white border border-[#D6D6D6] rounded-lg text-xl text-myNeutralTitle font-medium`}
                  ></textarea>
                  <form
                    method="dialog"
                    className={`w-full max-w-36 h-12 rounded-xl flex justify-between lg:justify-center items-center gap-8`}
                  >
                    <button
                      onClick={() => handleDenyRequest(denyState)}
                      className={`btn bg-[#EA4335] hover:bg-[#EA4335] rounded-lg font-bold text-white w-[182px]`}
                      style={{ border: "1px solid" }}
                    >
                      ارسال پیام
                    </button>
                  </form>
                </div>
              </div>
              <form method="dialog" className="modal-backdrop">
                <button>close</button>
              </form>
            </dialog>
          </div>

          {/* Member's Leaderboard */}
          {leaderboardData && leaderboardData?.length > 0 && (
            <div className={`mt-10 flex flex-col gap-7`}>
              <div className={`flex items-center gap-4`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.93263 10.4745C8.83627 10.4649 8.72064 10.4649 8.61464 10.4745C6.32123 10.3974 4.5 8.51838 4.5 6.2057C4.5 3.84484 6.40796 1.92725 8.77846 1.92725C11.1393 1.92725 13.0569 3.84484 13.0569 6.2057C13.0473 8.51838 11.226 10.3974 8.93263 10.4745Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.9192 3.85443C17.7886 3.85443 19.2919 5.36731 19.2919 7.22709C19.2919 9.04832 17.8464 10.5323 16.0445 10.5997C15.9674 10.5901 15.8807 10.5901 15.7939 10.5997"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.11469 14.0302C1.78273 15.5913 1.78273 18.1352 4.11469 19.6866C6.76463 21.4597 11.1105 21.4597 13.7605 19.6866C16.0924 18.1256 16.0924 15.5816 13.7605 14.0302C11.1202 12.2668 6.77427 12.2668 4.11469 14.0302Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7783 19.2724C18.4721 19.1278 19.1274 18.8484 19.667 18.434C21.1702 17.3066 21.1702 15.4468 19.667 14.3194C19.137 13.9147 18.4914 13.6448 17.8072 13.4907"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={`text-myBlack414 text-lg font-semibold`}>
                  لیدربورد اعضا
                </span>
              </div>
              <div className="overflow-x-auto max-h-[500px] relative">
                <table className="table table-pin-rows">
                  {/* head */}
                  <thead>
                    <tr className={`border-b-myNeutralBorder`}>
                      <th className={`text-myNeutralBody text-center bg-white`}>
                        ردیف
                      </th>
                      <th className={`text-myNeutralBody text-center bg-white`}>
                        نام
                      </th>
                      <th className={`text-myNeutralBody text-center`}>
                        نام خانوادگی
                      </th>
                      <th className={`text-myNeutralBody text-center`}>
                        شماره تلفن همراه
                      </th>
                      <th className={`text-myNeutralBody text-center`}>
                        زمان پیوستن به چالش
                      </th>
                      <th className={`text-myNeutralBody text-center`}>
                        رده سازمانی
                      </th>
                      <th className={`text-myNeutralBody text-center`}>
                        {isTypeReward
                          ? ` امتیاز (
                      ${eventDetails?.eventCategory?.indicatorMeasurementUnit})`
                          : eventDetails?.eventCategory.indicator}
                      </th>
                      {eventDetails?.eventCategory?.type?.dataEntryType ===
                        "ADMIN" && (
                        <>
                          <th className={`text-myNeutralBody text-center`}>
                            ورود امتیاز جدید بر اساس{" "}
                            {
                              eventDetails?.eventCategory
                                ?.indicatorMeasurementUnit
                            }
                          </th>
                          <th className={`text-center`}>
                            {/* <button
                        className={`btn shadow-none !p-2.5`}
                        // onClick={() => {
                        //   document.getElementById("filter_modal").showModal();
                        // }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                        >
                          <path
                            d="M9.84202 19.3734C9.44744 19.3734 9.06109 19.2747 8.69939 19.0775C7.976 18.6747 7.54032 17.943 7.54032 17.121V12.7642C7.54032 12.3532 7.26905 11.7367 7.01422 11.4243L3.9398 8.16903C3.42192 7.65115 3.02734 6.76335 3.02734 6.0975V4.20682C3.02734 2.89156 4.02201 1.86401 5.28794 1.86401H16.1388C17.3883 1.86401 18.3994 2.87512 18.3994 4.12461V5.93309C18.3994 6.79623 17.8815 7.77445 17.3965 8.25946L13.8371 11.4079C13.4919 11.6956 13.2206 12.3285 13.2206 12.8382V16.373C13.2206 17.1046 12.7603 17.9513 12.1848 18.2965L11.0504 19.0281C10.6805 19.2583 10.2613 19.3734 9.84202 19.3734ZM5.28794 3.09707C4.71252 3.09707 4.2604 3.58207 4.2604 4.20682V6.0975C4.2604 6.40165 4.50701 6.99352 4.81938 7.30589L7.95134 10.6023C8.37058 11.1201 8.7816 11.9833 8.7816 12.756V17.1128C8.7816 17.6471 9.15151 17.9102 9.3077 17.9924C9.65295 18.1814 10.0722 18.1814 10.3928 17.9841L11.5354 17.2525C11.7656 17.1128 11.9958 16.6689 11.9958 16.373V12.8382C11.9958 11.9586 12.4232 10.9886 13.0397 10.4707L16.5581 7.35522C16.8376 7.07572 17.1746 6.40987 17.1746 5.92487V4.12461C17.1746 3.55741 16.7142 3.09707 16.147 3.09707H5.28794Z"
                            fill="#EA4335"
                          />
                          <path
                            d="M5.78109 9.59117C5.66601 9.59117 5.55914 9.55829 5.45228 9.50075C5.16457 9.3199 5.07414 8.93354 5.25499 8.64583L9.30763 2.15174C9.48848 1.86403 9.86661 1.77361 10.1543 1.95445C10.442 2.1353 10.5325 2.51344 10.3516 2.80115L6.29898 9.29524C6.18389 9.4843 5.9866 9.59117 5.78109 9.59117Z"
                            fill="#EA4335"
                          />
                        </svg>
                      </button> */}
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {/* row 1 */}
                    {leaderboardData?.map((itm, i) => (
                      <tr
                        key={i}
                        className={`border-b-myNeutralBorder [&>td]:text-center`}
                      >
                        <th
                          className={`text-center max-lg:sticky max-lg:right-0 max-lg:bg-white`}
                        >
                          {i + 1}
                        </th>
                        <th className="max-lg:sticky max-lg:right-[56px] max-lg:bg-white text-center">
                          {itm?.firstName}
                        </th>

                        <td className={`text-myNeutralTitle`}>
                          {itm?.lastName}
                        </td>
                        <td className={`text-myNeutralTitle`}>
                          {itm?.mobileNumber}
                        </td>
                        <td className={`text-myNeutralTitle`}>
                          {moment(itm?.enrolledDate).format("jYYYY/jMM/jDD")}
                        </td>
                        <td className={`text-myNeutralTitle`}>
                          {itm?.organizationRole === "DIRECTORATE"
                            ? "رئیس/مدیرعامل"
                            : itm?.organizationRole === "DEPUTY"
                            ? "معاونت"
                            : "مدیریت"}
                        </td>
                        <td className={`text-myNeutralTitle`}>
                          {itm?.activity}
                        </td>
                        {eventDetails?.eventCategory?.type?.dataEntryType ===
                          "ADMIN" && (
                          <>
                            <td className={`text-myNeutralTitle`}>
                              {/* THIS INPUT */}
                              <input
                                className={`border border-[#D6D6D6] rounded-lg outline-none h-10 text-center`}
                                type="text"
                                value={entryValues[itm?.id]?.amount ?? ""}
                                onChange={e => {
                                  // keep only digits
                                  const raw = e.target.value.replace(/\D/g, "");
                                  // clamp to max if needed
                                  const clamped =
                                    isTypeReward &&
                                    maxChallengeReward != null &&
                                    toNumber(raw) > maxChallengeReward
                                      ? String(maxChallengeReward)
                                      : raw;

                                  setEntryValues(v => ({
                                    ...v,
                                    [itm.id]: {
                                      ...(v[itm.id] || { description: "" }),
                                      amount: clamped,
                                    },
                                  }));
                                }}
                                onKeyDown={e => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // stop form submission
                                    if (
                                      !rowLoading[itm?.id] &&
                                      normalizeDigits(
                                        entryValues[itm?.id]?.amount || ""
                                      )
                                    ) {
                                      submitDataEntry(itm?.id);
                                    }
                                  }
                                }}
                              />
                            </td>
                            <th className={`text-center`}>
                              <button
                                className="btn bg-myBlue257 hover:bg-myBlue257 text-white rounded-lg px-10"
                                onClick={() => submitDataEntry(itm?.id)}
                                disabled={
                                  rowLoading[itm?.id] ||
                                  !normalizeDigits(
                                    entryValues[itm?.id]?.amount || ""
                                  )
                                }
                              >
                                {rowLoading[itm?.id] ? "در حال ثبت..." : "ثبت"}
                              </button>
                            </th>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                  {/* foot */}
                  {/* <tfoot>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Job</th>
                <th>Favorite Color</th>
                <th></th>
              </tr>
            </tfoot> */}
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
